import React from "react";
export interface VerticalNavigationPageAreaProviderProps {
    value: VerticalNavigationPageArea | undefined;
    children: React.ReactNode;
}
export function VerticalNavigationPageAreaProvider({ value, children }: VerticalNavigationPageAreaProviderProps) {
    return <VerticalNavigationPageAreaContext.Provider value={value}>{children}</VerticalNavigationPageAreaContext.Provider>;
}
export function useVerticalNavigationPageArea() {
    return React.useContext(VerticalNavigationPageAreaContext);
}
export type VerticalNavigationPageArea = "Projects" | "Insights" | "Tasks" | "Configuration" | "User Profile" | "Dev Tools" | "Blueprints";
const VerticalNavigationPageAreaContext = React.createContext<VerticalNavigationPageArea | undefined>(undefined);
